<script>
  import { onMount } from "svelte";
  import SvelteMonetization from "svelte-monetization";
  export let date;
  export let totalAmount = 0;
  export const startTime = new Date();
  export let reachedGoalTime;

  onMount(async () => {
    const res = await fetch("/api/date");
    const newDate = await res.text();
    date = newDate;
  });

  function handleProgress(event) {
    totalAmount =
      totalAmount +
      parseInt(event.detail.amount) *
        Math.pow(10, -parseInt(event.detail.assetScale));

    if (!reachedGoalTime && totalAmount > 0.01) {
      reachedGoalTime = new Date();
    }
    // if (parent && parent.onProgress) parent.onProgress(event.detail);
    window.parent.postMessage({ ...event.detail }, "*");
  }
</script>

<svelte:head>
  <meta name="monetization" content="$ilp.uphold.com/9YpjygDp4XaP" />
</svelte:head>

<main>
  <SvelteMonetization
    let:isMonetized
    let:isLoading
    on:progress={handleProgress}>
    {#if isLoading}
      <div>Monetization is loading</div>
    {:else if isMonetized}
      <div style="text-align:left">
        <p>Total: {totalAmount}</p>
        {#if reachedGoalTime}
          <p>0.01 reached in {reachedGoalTime - startTime}</p>
        {/if}
      </div>
    {:else}
      <div>No monetization enabled</div>
    {/if}
  </SvelteMonetization>
</main>
